<template>
    <div class="my-profile-page">
        <h4>My Profile</h4>
        <hr>

        <div class="grid-container">
            <div class="my-profile__card card card-2 shadow-sm">
                <div class="card-header">
                    <h5 class="card-title">Personal Details</h5>
                    <hr>
                </div>
                <div class="card-body">
                    <div class="row mb-2">
                        <BasicTextInput  class="col-6" label="First Name" disabled="disabled" v-model="currentUser.FirstName"/>
                        <BasicTextInput  class="col-6" label="Last Name"  disabled="disabled" v-model="currentUser.LastName" />
                    </div>
                    <BasicTextInput   class="mb-2" label="Email" disabled="disabled" v-model="currentUser.EmailAddress" />
                    <div class="row mb-2">
                        <PhoneNumberInput class="col-6 mb-2" label="Phone" disabled="disabled" v-model="currentUser.PhoneNumber"  />
                        <BasicTextInput  class="col-6" label="Cost Center"   v-model="user.CostCenter" />
                    </div>
                </div>
            </div>

            <div class="my-profile__card card card-2 shadow-sm" v-if="can('access-msAccess-db-upload')">
                <div class="card-header">
                    <h5 class="card-title">Access DB Upload</h5>
                    <hr>
                </div>
                <div class="card-body">
                    <div class="container p-0 m-0">
                        <div class="d-flex justify-content-between align-items-center">
                            <FileInput ref="accessDatabaseFileUpload" v-on:fileSelected="stageFile" />
                        </div>
                        <div class="btn btn-secondary mr-2" v-if="tempFiles.length > 0" @click="clearFileUpload">Clear</div>
                        <div class="btn btn-primary"        v-if="tempFiles.length > 0" @click="uploadAccessDBFile">Upload</div>
                    </div>
                </div>
            </div>

            <div class="my-profile__card card card-2 shadow-sm" v-if="can('access-sales-tax-form')">
                <div class="card-header">
                    <h5 class="card-title">Sales Tax</h5>
                    <hr>
                </div>
                <div class="card-body">
                    <div class="container p-0 m-0">
                        <div class="row mb-2">
                            <div class="col">
                                <PercentInput placeholder="7.00%" label="Sales Tax" v-model="user.SalesTax"/>
                            </div>
                            <div class="col">
                                <Checkbox label="Round To The Nearest Dollar" v-model="user.RoundToNearestDollar"/>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col">
                                <DefaultFreightInput placeholder="7.00%" @isDefaultFreightPercentChanged="isDefaultFreightPercentChanged" :percentInput="user.IsDefaultFreightPercent" v-model="user.DefaultFreight"/>
                            </div>
                            <div class="col">
                                <Checkbox label="Tax Freight" v-model="user.TaxFreight"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <PercentInput placeholder="7.00%" label="GP" v-model="user.GPPercent"/>
                            </div>


                            <input type="text" id="username" style="maxWidth: 0px; maxHeight: 0px; z-index: -5"/>
                        </div>
                    </div>
                </div>
            </div>

            <UpdatePassword class="my-profile__card card card-2 shadow-sm"    />
        </div>

        <div class="btn-wrapper" v-if="can('see-user-profile-btns-that-are-unneccesary-for-smartsales-admin')">
            <!-- <button type="button" class="btn btn-secondary">Cancel</button> -->
            <div  @click="saveCurrentUser" class="btn btn-primary">Save</div>
        </div>
    </div>
</template>

<script>
    import { mapState }                             from 'vuex';
    import { UserService, DealerService }           from '@/services'
    import UpdatePassword                           from '@/components/UpdatePassword.vue';
    import DefaultFreightInput                      from '@/components/inputComponents/DefaultFreightInput';

    export default {
        name: "MyProfile",
        components: {
          UpdatePassword,
          DefaultFreightInput
        },
        data() {
            return {
                user: {},
                tempFiles: [],
            }
        },
        methods: {
            uploadAccessDBFile(){
                if (this.tempFiles.length < 1){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'No File Selected', type: 'error' });
                    return;
                }
                DealerService.uploadAccessDB(this.tempFiles[0]).then(res => {
                    this.clearFileUpload();
                    this.$store.dispatch('ADD_NOTIFICATION', { text:'Access Database Uploaded Successfully', type: 'success' });
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response, type: 'error' });
                })
            },
            clearFileUpload(){
                this.tempFiles = [];
                this.$refs.accessDatabaseFileUpload.clear();
            },
            saveCurrentUser(){
                UserService.update(this.user).then(res => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'User Updated', type: 'success' });
                    }).catch(err => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
                    })

            },
            isDefaultFreightPercentChanged(isDefPercent){
                this.user.IsDefaultFreightPercent = isDefPercent;
            },
            getCurrentUser(){
                UserService.get().then(res => {
                    console.log(res);
                    this.user = res;
                }).catch(err => {
                    console.error(err);
                })
            },
            stageFile(f){
                this.tempFiles.push(f[0]);
            },
        },
        computed: {
            ...mapState(['currentUser']),
        },
        mounted(){
            this.getCurrentUser()
        }
    }
</script>

<style scoped lang="scss">
    .my-profile-page{
        // max-width: 1800px
    }
    .grid-container {
        display: grid;
        grid-template-columns: 50% 50%;
        grid-template-rows: auto;

        .my-profile__card {
            margin: 10px;
        }
    }

    .btn-wrapper {
        width: 100%;
        padding: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .btn {
          margin: 5px;
        }
    }
</style>
